import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let PageLoadingNew = class PageLoadingNew extends Vue {
};
tslib_1.__decorate([
    Prop({ default: String })
], PageLoadingNew.prototype, "loadingText", void 0);
tslib_1.__decorate([
    Prop({ default: Boolean })
], PageLoadingNew.prototype, "loading", void 0);
PageLoadingNew = tslib_1.__decorate([
    Component({
        name: "page-loading-new",
        components: {},
    })
], PageLoadingNew);
export default PageLoadingNew;
